import { parse } from "content-disposition";
import { saveAs } from "file-saver";

function getFilenameFromResponse(response: Response): string | undefined {
  const header = response.headers.get("Content-Disposition");
  if (!header) {
    return undefined;
  }

  try {
    const parsed = parse(header);
    return parsed.parameters.filename;
  } catch {
    return undefined;
  }
}

export async function downloadResponse(
  response: Response,
  fallbackFilename: string
): Promise<void> {
  const filename = getFilenameFromResponse(response) ?? fallbackFilename;
  saveAs(await response.blob(), filename);
}
